/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       PeriodImage.tsx
 * @author     Christian Ascone
 * @date       10/22/19 11:56 AM
 */

import React from 'react';
import {Image} from "react-native";

export function PeriodImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/period.png')
            }
        />
    );
}